import styled from 'styled-components';
import { EstadoSaude } from './saude';

export const Container = styled.div`
  padding: 16px;
`;

export const Alerta = styled.div`
  margin-bottom: 16px;
  padding: 10px 14px;
  border: 1px solid ${({ theme }) => theme.dangerColor};
  border-left-width: 4px;
  border-radius: 8px;
  font-size: 13px;
  color: ${({ theme }) => theme.dangerColor};
  background-color: ${({ theme }) =>
    theme.isDark ? 'rgba(197, 48, 48, 0.15)' : theme.dangerLightColor};
`;

/** Cor por estado: verde integrada, ambar atrasada, vermelho pendente. */
const cores = {
  ok: 'successColor',
  atrasada: 'warningColor',
  nunca: 'dangerColor',
  incompleta: 'dangerColor',
  inativa: 'darkGray',
} as const;

export const Badge = styled.span<{ estado: EstadoSaude }>`
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme, estado }) => theme[cores[estado]]};
`;

export const Detalhe = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.darkGray};
`;

export const Url = styled.span`
  font-size: 12px;
  word-break: break-all;
  color: ${({ theme }) => theme.darkGray};
`;
